import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ISubscriptionPlan } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";

// const schema = yup.object({
//     plan_Name: yup.string().required("Plan is required"),
//     plan_Desc: yup.string().nullable(),
//     plan_Duration: yup.number().required("Plan is required").typeError("Plan Duration is a number"),
//     plan_Cost: yup.number().required("Plan is required").typeError("Plan Cost is a number"),
//     plan_Status: yup.boolean().nullable(),

// });
const schema = yup.object({
    plan_Name: yup.string().required("Plan is required"),
    plan_Desc: yup.string().nullable(),

    plan_Duration: yup
        .number()
        .typeError("Plan Duration must be a number")
        .integer("Plan Duration must be an integer")
        .positive("Plan Duration must be greater than 0")
        .required("Plan Duration is required"),

    plan_Cost: yup
        .number()
        .typeError("Plan Cost must be a number")
        .integer("Plan Cost must be an integer")
        .positive("Plan Cost must be greater than 0")
        .required("Plan Cost is required"),

    plan_Status: yup.boolean().nullable(),
});

interface Iprops {
    singleData: ISubscriptionPlan,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<ISubscriptionPlan>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: ISubscriptionPlan) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`subscription_Plan${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }
    
    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit  Plan" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={1} required label="Plan Name" control={control} name="plan_Name" error={errors.plan_Name?.message} />
                <JVInput  type="number" column={1} required label="Plan Duration" control={control} name="plan_Duration" error={errors.plan_Duration?.message} />
                <JVInput type="number" column={1} required label="Plan Cost" control={control} name="plan_Cost" error={errors.plan_Cost?.message}  />
                <JVInput column={1} label="Description" control={control} name="plan_Desc" error={errors.plan_Desc?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}